<template>
  <div class="form-buttons__security" :class="{ crezu: isCrezu }">
    <div class="form-buttons__security-info">{{text}}</div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'SecurityBadge',
  computed: {
    isCrezu: () => window.location.hostname.includes('crezu') || window.location.hostname.includes('localhost')
  },
  props: {
    text: {
      type: String,
      default: ''
    }
  }
}
</script>

<style lang="scss" scoped>
.form-buttons {
  &__security {
    display: flex;
    width: 100%;
    margin-top: 10px;

    &-info {
      display: inline-flex;
      margin: auto;
      align-items: center;
      gap: 5px;
      font-size: 12px;
      font-weight: 500;
      line-height: 16px;
      text-align: center;
      color: var(--btn);

      &::before {
        content: '';
        display: block;
        width: 18px;
        height: 18px;
        mask-image: url('https://cdn.crezu.net/reg_form/src/static/icons/info-icon.svg');
        mask-size: contain;
        background-color: var(--btn);
      }
    }

    &.crezu {
      .form-buttons__security-info {
        font-size: 14px;
        font-weight: 400;
        line-height: 21px;
        color: var(--white-sixty);

        &::before {
          mask-image: none;
          width: 19px;
          height: 19px;
          background-image: url('https://cdn.crezu.net/reg_form/src/static/icons/info-icon-with-bg.svg');
          background-color: transparent;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/assetComponents/SecurityBadge.vue